<template>
  <section :class="{ guarantee: true, 'zero-offset': true, 'gray-bg': lang === 'ru' }" id="guarantee-section">
    <div class="content">
      <h1 :class="{ 'font-weight-bold': lang === 'ru' }" v-text="translations[lang].title" class="title" />
      <div class="guarantee-profits">
        <div v-for="(item, index) in translations[lang].items" :key="index" class="guarantee-profits__item">
          <h5 :class="{ 'font-weight-medium': lang === 'ru' }" v-text="item.title" />
          <p v-html="item.subtitle" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Guarantee',
  props: {
    lang: {
      type: String,
      default: 'en',
    },
  },
  data: () => ({
    translations: {
      en: {
        items: [
          {
            subtitle: 'We offer high quality materials at lowest price',
            title: 'Lowest price',
          },
          {
            subtitle: 'We guarantee your money back if you are unhappy with the result',
            title: 'Moneyback',
          },
        ],
        title: 'Your guarantee',
      },
      ru: {
        items: [
          {
            subtitle: 'Мы предлагаем материалы высокого качества по самой доступной цене на рынке',
            title: 'Цена-качество',
          },
          {
            subtitle: 'Вернем деньги, если вам не понравится <br/>результат',
            title: 'Держим слово',
          },
        ],
        title: 'Ваши гарантии',
      },
    },
  }),
};
</script>
